/**
 * Connector icon component.
 * CoOrdio Design System — Lucide icons mapped by connector key/category.
 */

import type { SvgIconProps } from '@mui/material';
import {
  ShieldCheck,
  Mail,
  ClipboardList,
  Cloud,
  Hospital,
  Type,
  Brain,
  Webhook,
} from '@core/components/icons';

export interface ConnectorIconProps extends SvgIconProps {
  connectorKey: string;
  category?: string;
}

const iconSize = 24;

/**
 * Connector icon component that maps connector keys to CoOrdio DS (Lucide) icons.
 */
export const ConnectorIcon = ({ connectorKey, category }: ConnectorIconProps) => {
  const key = connectorKey.toLowerCase();
  const cat = category?.toLowerCase() || '';

  if (key === 'data_validation' || cat === 'data validation') {
    return <ShieldCheck size={iconSize} style={{ color: 'inherit' }} />;
  }

  if (key === 'email' || cat === 'communication') {
    return <Mail size={iconSize} style={{ color: 'inherit' }} />;
  }

  if (key === 'task_management' || cat === 'task management') {
    return <ClipboardList size={iconSize} style={{ color: 'inherit' }} />;
  }

  if (key === 'blob_storage' || cat === 'storage') {
    return <Cloud size={iconSize} style={{ color: 'inherit' }} />;
  }

  if (key === 'fhir' || cat === 'healthcare') {
    return <Hospital size={iconSize} style={{ color: 'inherit' }} />;
  }

  if (key === 'ocr' || cat === 'document processing') {
    return <Type size={iconSize} style={{ color: 'inherit' }} />;
  }

  if (key === 'rag' || cat === 'ai/ml') {
    return <Brain size={iconSize} style={{ color: 'inherit' }} />;
  }

  return <Webhook size={iconSize} style={{ color: 'inherit' }} />;
};
